import { createApiClient, apiClient, getLocalTimestamp, getTimezoneOffsetString } from '../../../api/apiClient';
import type { ActionPlanApiResponse, ApiActionPlanDetails } from '../types';

export type FetchActionPlanByIdOptions = {
  isTemp?: boolean;
};

export const fetchActionPlanById = async (
  actionPlanId: string,
  options: FetchActionPlanByIdOptions = {}
): Promise<ActionPlanApiResponse<ApiActionPlanDetails>> => {
  const { isTemp = false } = options;

  const api = createApiClient();
  const clientTimestamp = getLocalTimestamp();
  const clientTimezone = getTimezoneOffsetString();

  const endpoint = `/action-plans/${encodeURIComponent(actionPlanId)}?is_temp=${encodeURIComponent(
    String(isTemp)
  )}&clientTimestamp=${encodeURIComponent(clientTimestamp)}&clientTimezone=${encodeURIComponent(clientTimezone)}`;

  return apiClient(api, endpoint, 'GET');
};
